module.exports = __webpack_public_path__ + "static/img/WS.1aecd25c.svg";